import React from 'react';
import { NewsCards } from '@domain-group/fe-co-allhomes-article-card';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ArticleCards = _ref => {
  var _ref$articles = _ref.articles,
    articles = _ref$articles === void 0 ? [] : _ref$articles,
    sectionName = _ref.sectionName;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  return ___EmotionJSX(NewsCards, {
    articles: articles,
    onClick: cardIndex => {
      sendEvent('view-article-click', {
        sectionName,
        index: cardIndex
      });
    }
  });
};
export { ArticleCards };